import { Locale, type LocalizedString } from "../Locale.js";

export const referencesAnchorPathMap = {
	[Locale.cs]: "#reference" as const,
} satisfies LocalizedString;
